<template>
  <v-container fluid grid-list-xl page>
    <v-layout row wrap>
      <v-flex xs12 sm8 md12>
        <section-header v-text="page.headline"></section-header>
        <div class="subheading justify" v-html="page.description"></div>
        <div class="my-5"></div>
      </v-flex>
    </v-layout>
    <!-- Your contet -->

    <div class="display-2 grey--text text--darken-1">
      Verifica documentos y extrae sus datos
    </div>
    <div class="title grey--text text--darken-1">
      desde cualquier dispositivo, sin necesidad de instalar aplicaciones
    </div>

    <v-layout>
      <v-flex>
        <v-card class="justify-center">
          <v-container fluid grid-list-md>
            <v-layout row wrap class="justify-center">
              <v-flex xs12 md6 lg3 offset-2>
                <v-card flat tile>
                  <v-img
                    justify-center
                    src="/static/send.png"
                    width="100"
                    aspect-ratio="1"
                  ></v-img>

                  <v-card-title primary-title>
                    <div>
                      <h3 class="headline mb-0">PROCESA</h3>
                      <div>
                        Analiza de forma automática si un documento de identidad
                        es válido y extrae la iinformación impresa. Puedes analizar las imágenes que contengan el anverso y reverso de un docuumento de identidad, obtener el recorte de las mismas y los datos del documento
                      </div>
                    </div>
                  </v-card-title>

                  <!-- <v-card-actions>
                    <v-btn flat color="orange">Share</v-btn>
                    <v-btn flat color="orange">Learn More</v-btn>
                  </v-card-actions> -->
                </v-card>
              </v-flex>

              <!-- --------- -->

              <v-flex xs12 md6 lg3>
                <v-card flat tile>
                  <v-img
                    src="/static/digital-signature.png"
                    width="100"
                    aspect-ratio="1"
                  ></v-img>

                  <v-card-title primary-title xs12 sm3>
                    <div>
                      <h3 class="headline mb-0">ANALIZA Y TRANSFORMA</h3>
                      <div>
                        Securyty descubrirá el tipo de documento en una imagen,
                        hará el recorte ( crop ) de la misma para dejar
                        únicamente la parte correspondiente al documento y
                        extaerá sus datos ( nombre, núumero de docuemtno, fecha
                        de caducidad, etc ).
                      </div>
                    </div>
                  </v-card-title>

                  <!-- <v-card-actions>
                    <v-btn flat color="orange">Share</v-btn>
                    <v-btn flat color="orange">Learn More</v-btn>
                  </v-card-actions> -->
                </v-card>
              </v-flex>

              <v-flex xs12 md6 lg3>
                <v-card flat tile>
                  <v-img
                    s
                    src="/static/admin.png"
                    width="100"
                    aspect-ratio="1"
                  ></v-img>

                  <v-card-title primary-title xs12 sm3>
                    <div>
                      <h3 class="headline mb-0">GESTIONA</h3>
                      <div>
                        Puedes visualizar cualquiera de los documentos
                        procesados y exportar las imágeenees y la información.
                        Fácilmente integrable en tus procesos de negocio.
                      </div>
                    </div>
                  </v-card-title>

                  <!-- <v-card-actions>
                    <v-btn flat color="orange">Share</v-btn>
                    <v-btn flat color="orange">Learn More</v-btn>
                  </v-card-actions> -->
                </v-card>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card>
      </v-flex>
    </v-layout>
    <v-spacer></v-spacer>
 

    <v-layout height="100">
      <v-card height="100" flat color="grey"> </v-card>
    </v-layout>

    <div class="display-2 black--text text--darken-3 justify-center">
      Procesos sencillos y legales
    </div>
    <div class="title black--text text--darken-1">
      desde cualquier dispositivo
    </div>

    <v-dialog v-model="isCreateSign" persistent max-width="500px">
      <v-card>
        <v-toolbar color="orange" dark>
          <!-- <v-toolbar-side-icon></v-toolbar-side-icon> -->
          <v-toolbar-title>Procesa un documento</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-tooltip right>
            <v-icon slot="activator" color="white" dark>help_outline</v-icon>
            <span><b>Analiza imágenes de documentos de identidad</b> </span>
          </v-tooltip>
        </v-toolbar>
        <v-btn
          round
          color="red darken-4"
          dark
          bold
          outline
          @click="gotoOcrPage()"
          >Analiza un documento</v-btn
        >
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            round
            color="red darken-4"
            dark
            bold
            outline
            @click.native="closeSignaturePage"
            >Cerrar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="isLoginNeeded" max-width="300px">
      <v-card>
        <v-toolbar color="orange" dark>
          <!-- <v-toolbar-side-icon></v-toolbar-side-icon> -->
          <v-toolbar-title>Es necesario estar Logado</v-toolbar-title>
          <v-spacer></v-spacer>
          <!-- <v-tooltip right>
            <v-icon
                slot="activator"
                color="white"
                dark
              >help_outline</v-icon>

          </v-tooltip> -->
        </v-toolbar>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap></v-layout>
            <span
              >Por favor, accede a tu cuenta o registrate antes de iniciar la
              prueba
            </span>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            round
            color="orange darken-4"
            dark
            bold
            outline
            @click.native="isLoginNeeded = false"
            >Cerrar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogOcrFrame" width="90%">
      <v-card>
        <iframe
          style="width:100%"
          height="700px"
          src="https://videoservices.securyty.com/securyty/cropper/"
        ></iframe>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            round
            color="orange darken-4"
            dark
            bold
            outline
            @click="closeIframe()"
            >Cerrar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
export default {
  components: {},
  // mounted() {
  //   // Google Analytics
  //   this.$ga.page(this.$router);
  // },
  data() {
    return {
      isLoginNeeded: false,
      isCreateSign: false,
      dialogOcrFrame: false,
      page: {
        title: "Verificación de Documentos",
        headline: "Verificación de Documentos",
        description: `Recorta y extrae datos `
      },
      breadcrumbs: [
        {
          text: "Src",
          disabled: false
        },
        {
          text: "Views",
          disabled: false
        },
        {
          text: "Blank",
          disabled: false
        }
      ],
      scrollTop: 0
    };
  },
  methods: {
    createSignature() {
      //this.$router.push("CreateSignPage")
      var current = this.$store.getters.userData;
      if (current == null || current.userEmail == null) {
        this.isLoginNeeded = true;
        this.$ga.event({
          eventCategory: "Loggin needed simple signature", // str
          eventAction: "click", // str
          eventLabel: "TryButton", // str
          eventValue: 0 // int
        });
        return;
      }
      this.scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      document.getElementsByTagName("body")[0].className = "noscroll";
      // this.isCreateSign = true;
      this.dialogOcrFrame = true;
    },
    closeSignaturePage() {
      document.body.removeAttribute("class", "noscroll");
      window.scrollTo(0, this.scrollTop);
      this.isCreateSign = false;
    },
    gotoOcrPage() {
      this.dialogOcrFrame = true;
      //  window.location="https://videoservices.securyty.com/securyty/cropper/";
      //this.$router.push({ name: "ContactPage" });
    },
    closeIframe() {
      document.body.removeAttribute("class", "noscroll");
      window.scrollTo(0, this.scrollTop);
      this.dialogOcrFrame = false;
    }
  }
};
</script>
